export default __webpack_public_path__ + "static/media/type_8_4.b06320fa.svg";